export default "__VITE_ASSET__BSqJgxrs__"